import React from "react";

const DeviceIdsContext = React.createContext({});

export default DeviceIdsContext;
